import { reactive } from 'vue';

const DEFAULT_FILTERS = {
  status: 'open',
  period: '30d',
  view: 'mine',
  query: '',
  page: 1,
};

export const filters = reactive({ ...DEFAULT_FILTERS });

export const resetFilters = () => {
  Object.assign(filters, DEFAULT_FILTERS);
};
